import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oxd_input_group = _resolveComponent("oxd-input-group")!

  return (_openBlock(), _createBlock(_component_oxd_input_group, {
    label: _ctx.label,
    labelIcon: _ctx.labelIcon,
    message: _ctx.message,
    class: "oxd-input-field-bottom-space",
    classes: _ctx.classes
  }, {
    default: _withCtx(() => [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.component), _mergeProps(_ctx.$attrs, {
        disabled: _ctx.disabled,
        hasError: _ctx.hasError,
        modelValue: _ctx.modelValue,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
      }), _createSlots({ _: 2 }, [
        _renderList(_ctx.$slots, (_, name) => {
          return {
            name: name,
            fn: _withCtx((slotData) => [
              _renderSlot(_ctx.$slots, name, _normalizeProps(_guardReactiveProps(slotData)))
            ])
          }
        })
      ]), 1040, ["disabled", "hasError", "modelValue"]))
    ]),
    _: 3
  }, 8, ["label", "labelIcon", "message", "classes"]))
}